/**
 * 通讯录 Tab 懒加载壳（21q 轮补；MeTabLazy 同构）。
 *
 * 首屏默认落 chats Tab，通讯录只有点过去（或深链 /contacts）才需要——
 * 按 PROMPT「非首屏功能一律动态 import」拆出去。它连带拖走 contactsState 的
 * 展开/分组模型与一串 nav actions。
 *
 * ⚠️ 与 MeTab 的一点不同：通讯录在**桌面左栏**也会被渲染，所以加载态要撑满
 * 容器而不是一行字贴在角上；testid 与 MeTab 同构，e2e 若要等就绪一律等
 * `page-contacts` 里的真内容。
 */
import { useLazyModule } from './useLazyModule';
import { ContactsSkeleton } from '~/ui/Skeleton';

export function ContactsPageLazy() {
  const { mod } = useLazyModule(() => import('./ContactsPage'));
  if (mod === null) return <ContactsSkeleton />; // 21w：骨架占位，见 ui/Skeleton
  return <mod.ContactsPage />;
}
